import axios from 'axios';
import {Modal} from 'iview';
import {sortByKey} from '@/utils/validate';
import Router from '@/router';
import md5 from 'js-md5'

// var requestUrls = {};
// 创建axios实例
const service = axios.create({
    baseURL: process.env.LOGIN_URL, // api的base_url
    timeout: 15000, // 请求超时时间
});
// request拦截器
service.interceptors.request.use(config => {

    /*if (process.env.NODE_ENV == 'development'){

    }*/
    config.method = config.type ? config.type : 'POST';
    config.withCredentials = true;
    config.data = config.data ? config.data : {};
    var token =  window.localStorage.getItem('xhqstoragetoken');
    if (token) {
        config.headers['token'] = token;
    }
    var jsonStr = JSON.stringify(sortByKey(config.data)), timestamp = new Date().getTime().toString();
    config.headers['sign'] = md5(jsonStr + 'c00bdedc-1f13-4beb-8482-b6f11b8ed52d' + timestamp);
    config.headers['timestamp'] = timestamp;
    config.headers['systemCode'] = '';
    config.headers['appId'] = '20f74b27-0a95-4aab-a8b3-d50a2735aa4d';
    // config.headers['version'] = '1.0';
    return config;
}, error => {
    // Do something with request error
    Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
    response => {
        /* var url = md5(response.config.url);
         requestUrls[url] = false;*/
       /* if (process.env.NODE_ENV == 'development') {
        }*/
        var xhr = response.data,code = xhr.code,reqDataObj;
        if (response.config.data) {
            reqDataObj = JSON.parse(response.config.data);
        }
        //其他
        if (code == 200) {
            return xhr.content;
        } else {
            window.localStorage.removeItem('xhqstoragetoken'); //清除数据
            window.location.href=process.env.LOGOUT_URL+'?service='+window.location.origin;
            return Promise.reject(xhr);
        }
    },
    error => {
        Modal.error({
            title: '服务器异常',
            closable: true,
            content: '服务器异常，建议稍后重试'
        });
        return Promise.reject(error);
    }
);

export default function (options) {
    return service(options);
}



// WEBPACK FOOTER //
// ./src/utils/login-fetch.js